import { useEffect, useRef, useState } from "react";
import Header from "../components/Header/Header";
import MobileHeaderSearch from "../components/Header/MobileHeaderSearch";
import Suspence from "../components/Suspence/Suspence";
import useAllApiCall from "../hooks/useAllApiCall";
const MainWrapper = ({ children, refrence }: { children: any, refrence?: any }) => {
  const allApiCall = useAllApiCall();
  const isApiCall = useRef(false)
  useEffect(() => {
    if (isApiCall.current == false) {
      isApiCall.current = true
      allApiCall.getStoreInfo()
    }

    return () => {
      isApiCall.current = false
    }

  }, [])
  if (!allApiCall?.isStoreDataFetched) {
    return <Suspence />;
  }

  return (
    <>
      <div className="topheader hidden md:block">
        <div className="pageHeader">
          <Header />
        </div>
      </div>
      <div
        //  className=" md:pt-[4.15rem] "
        className={`${refrence == 'about' ? ' md:pt-[3.7rem]' : ' md:pt-[4.15rem]'}`}

      >{children}</div>
    </>
  );
};
export default MainWrapper;
